module.exports = __webpack_public_path__ + "img/rml-rmb-rms.47a8afc9.png";